import { FormGroupInterface } from '@kaiser-software/chassis-core/src/app/forms/form/interfaces';

export const FormInterfaces = [];

export interface FormInterface {
    groups: FormGroupInterface[]
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form.interfaces.ts